import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const DemoBadgeWrap = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.25rem 0.625rem;
  border-radius: 999px;
  font-size: ${tokens.font.micro};
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: ${tokens.status.warning.fg};
  background: ${tokens.status.warning.bg};
  border: 1px solid ${tokens.border.hairline};
`

export const BannerWrap = styled.div<{ $tone: 'danger' | 'warning' }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.625rem 0.875rem;
  margin-bottom: 1rem;
  border-radius: ${tokens.radius.control};
  border: 1px solid ${({ $tone }) => ($tone === 'danger' ? tokens.status.danger.fg : tokens.border.hairline)};
  background: ${({ $tone }) => ($tone === 'danger' ? tokens.status.danger.bg : tokens.status.warning.bg)};
`

export const BannerText = styled.div<{ $tone: 'danger' | 'warning' }>`
  font-size: ${tokens.font.body};
  font-weight: 600;
  color: ${({ $tone }) => ($tone === 'danger' ? tokens.status.danger.fg : tokens.status.warning.fg)};
`

export const SchedulerMeta = styled.span`
  font-size: ${tokens.font.label};
  color: ${tokens.text.muted};
`
